var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-xl border border-pink-500 py-8 px-5 text-sm lg:text-base",staticStyle:{"background-color":"rgba(181, 3, 208, .1)"}},[_c('p',{staticClass:"mb-5"},[_c('b',[_vm._v("Have questions?")]),_vm._v(" We have the answers. Check out the FAQs.")]),_c('p',[_c('b',[_vm._v("Have any issues with your order?")]),_vm._v(" Visit the Resolution Center.")])])
}]

export { render, staticRenderFns }